(function() {
	'use strict';

	var $ = avm.require('cash'),
		$tablesTooltip = $('.tables__tooltip');

	//
	//	Keyboard accessible Tooltips - show tooltip when focused
	//
	$tablesTooltip.on('focus', function(e){
		$( this ).trigger('mouseenter');
	}).on('blur', function(e){
		$( this ).trigger('mouseleave');
	});

})();
